export type STATUS_TYPE = 'idle' | 'pending' | 'succeeded' | 'failed';


export type IParams = {
  id: string;
};

export enum Language {
  english = "en",
  arabic = "ar",
}

export enum SuperUserRole {
  admin = "admin",
  adminTier2 = "adminTier2",
  adminTier3 = "adminTier3",
  company = "company",
  individual = "individual",
  broker = "broker",
  agent = "agent",
}

export enum DocumentType {
  UserProfile = "userprofile",
  PropertyCategory = "property_category",
  PropertySubCategory = "property_sub_category",
  LocationManagement = "location_management",
  PropertyFeature = "property_feature",
  PropertyFacility = "property_facility",
  Advertise = "advertise",
  BrokerLicense = "broker_license",
  IDAttachment = "id_attachment",
  TitleDeed = "title_deed",
  IndividualID = "individual_id",
  TradeRegistration = "trade_registration",
  TradeSignatory = "trade_signatory",
}

export enum AdvertiseStatus {
  draft = "draft",
  submit = "submit",
  pending = "pending",
  approved = "approved",
  rejected = "rejected",
  published = "published",
  expired = "expired",
  suspended = "suspended",
  unPublished = "unPublished",
}

export enum PushNotificationType {
  location = "location",
  language = "language",
  allUsers = "allUsers",
  corporate = "corporate",
  individual = "individual",
}

export enum SortBy {
  advertiseNumber = "advertiseNumber",
  title = "title",
  price = "price",
  startDate = "startDate",
  endDate = "endDate",
  status = "status",
  name = "name",
  email = "email",
  mobileNumber = "mobileNumber",
  userRole = "userRole",
  activeState = "activeState",
  isApproved = "isApproved",
  userName = "userName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  packageName = "packageName",
  user = "user",
  paymentDate = "paymentDate",
  paymentAmount = "paymentAmount",
  paymentStatus = "paymentStatus",
}


export enum RentFrequency {
  day = "day",
  month = "month",
  year = "year",
}

export enum PropertyPossessionType {
  forRent = "75d2a87b-f99b-419c-a087-442bd87cea59",
  forSale = "1938c277-b8be-4e9a-9854-bb8965e591e7",
}

export enum ContactFormType {
  inquiry = "inquiry",
  report = "report",
  suggestion = "suggestion",
  changeEmail = "changeEmail",
  changeMobileNumber = "changeMobileNumber"
}